module.exports = require("./lib/fetch-rails");